"use strict";
/**
 * Argos → Heracles webhook event types and payloads.
 *
 * Argos (Rust) fires a POST to Heracles /internal/argos/ltvEvent after each
 * material LTV state transition. Heracles uses these events to trigger email
 * and push-notification communications via cryptoCommunicationManager.
 *
 * The account_label follows the pattern "loan-application-{loanApplicationId}".
 *
 * Numeric fields are pre-formatted strings to avoid floating-point precision
 * issues over the wire:
 *   current_ltv    → "72%"
 *   btc_amount     → "0.10000000 BTC"
 *   usd_proceeds   → "$10,000.00"
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgosLtvEventType = void 0;
/** @TranslateToRust */
var ArgosLtvEventType;
(function (ArgosLtvEventType) {
    // Draw-lock events
    ArgosLtvEventType["DrawLockTriggered"] = "draw_lock_triggered";
    ArgosLtvEventType["DrawLockCleared"] = "draw_lock_cleared";
    // Margin-call events
    ArgosLtvEventType["MarginCallInitialized"] = "margin_call_initialized";
    ArgosLtvEventType["MarginCallCancelled"] = "margin_call_cancelled";
    ArgosLtvEventType["MarginCallLiquidationExecuted"] = "margin_call_liquidation_executed";
    // Liquidation events
    ArgosLtvEventType["PartialLiquidationCompleted"] = "partial_liquidation_completed";
    ArgosLtvEventType["FullLiquidationCompleted"] = "full_liquidation_completed";
    // Transfer events
    ArgosLtvEventType["DepositConfirmed"] = "deposit_confirmed";
    ArgosLtvEventType["WithdrawalCompleted"] = "withdrawal_completed";
    // Warning
    ArgosLtvEventType["LtvWarningTriggered"] = "ltv_warning_triggered";
    ArgosLtvEventType["LtvWarningCleared"] = "ltv_warning_cleared";
})(ArgosLtvEventType || (exports.ArgosLtvEventType = ArgosLtvEventType = {}));
